import React, { useState, useEffect } from "react";
import LinkTypeSelector from "./LinkTypeSelectorComponent/LinkTypeSelector";
import ButtonComponent from "./ButtonComponent/ButtonComponent";
import AlternativeTextComponent from "./AlternativeTextComponent/AlternativeTextComponent";
// import ActionCheckboxes from "./ActionCheckboxComponent/ActionCheckboxes";
import Button from "@material-ui/core/Button";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import { makeStyles } from "@material-ui/core";

const defaultBgColor = { r: 40, g: 51, b: 113, a: 1 };
const defaultFgColor = { r: 255, g: 255, b: 255, a: 1 };

const defaultSettings = {
  type: "settlement_portal",
  link_type: "url",
  button_label: "",
  link_text: "",
  auto_login: false,
  open_payment_box: false,
  created: null,
  updated: null,
};

const useStyles = makeStyles({
  helperText: { fontSize: "12px !important" },
});

function SettlementPortalLinkPopup({
  open,
  close,
  onAdd,
  wordClicked,
  oldSettlementPortalOptions,
}) {
  const classes = useStyles();

  const [errorMessage, setErrorMessage] = useState("");
  const [buttonColors, setButtonColors] = useState({
    bgColor: defaultBgColor,
    fgColor: defaultFgColor,
  });

  const [settlementPortalSettings, setSettlementPortalSettings] = useState({
    ...defaultSettings,
  });

  // Initialize state based on wordClicked
  useEffect(() => {
    if (oldSettlementPortalOptions) {
      setSettlementPortalSettings((prev) => ({
        ...prev,
        ...oldSettlementPortalOptions,
        button_label: oldSettlementPortalOptions.button_label || "",
        link_text: oldSettlementPortalOptions.link_text || "",
      }));

      if (
        oldSettlementPortalOptions.button_bg_color &&
        oldSettlementPortalOptions.button_fg_color
      ) {
        setButtonColors({
          bgColor: oldSettlementPortalOptions.button_bg_color,
          fgColor: oldSettlementPortalOptions.button_fg_color,
        });
      }
    } else {
      setSettlementPortalSettings({ ...defaultSettings });
      setButtonColors({
        bgColor: defaultBgColor,
        fgColor: defaultFgColor,
      });
    }
  }, [oldSettlementPortalOptions]);

  const handleLinkTypeChange = (value) => {
    setSettlementPortalSettings((prev) => ({
      ...prev,
      link_type: value,
    }));
    setErrorMessage(""); // Clear error message on type change
  };

  // Handle text change for button_label or link_text
  const handleTextChange = (newText) => {
    setSettlementPortalSettings((prev) => {
      if (prev.link_type === "button") {
        return { ...prev, button_label: newText };
      } else if (prev.link_type === "alternative text") {
        return { ...prev, link_text: newText };
      }
      return prev;
    });
    setErrorMessage(""); // Clear error message on input change
  };

  // Handle color changes for button
  const handleColorChange = (type, color) => {
    setButtonColors((prev) => ({
      ...prev,
      [type]: color,
    }));
  };

  // Validate required fields
  const validateSettings = () => {
    const { link_type, button_label, link_text } = settlementPortalSettings;

    if (link_type === "button" && !button_label.trim()) {
      return "Please enter a button label.";
    }
    if (link_type === "alternative text" && !link_text.trim()) {
      return "Please enter alternative text.";
    }
    return null; // No errors
  };

  // Handle form submission
  const handleSubmit = () => {
    const error = validateSettings();
    if (error) {
      setErrorMessage(error);
      return;
    }

    const nowDate = new Date();
    const { link_type, button_label, link_text, auto_login, created } =
      settlementPortalSettings;

    const payload = {
      type: "settlement_portal",
      link_type,
      button_label: link_type === "button" ? button_label.trim() : null,
      link_text: link_type === "alternative text" ? link_text.trim() : null,
      button_bg_color:
        link_type === "button" ? buttonColors.bgColor : defaultBgColor,
      button_fg_color:
        link_type === "button" ? buttonColors.fgColor : defaultFgColor,
      auto_login,
      updated: nowDate,
      ...(created ? {} : { created: nowDate }),
    };

    onAdd("settlement_portal", payload);
    setErrorMessage(""); // Clear any previous error messages
    handleClose();
  };

  // Reset state and close the popup
  const handleClose = () => {
    setSettlementPortalSettings({ ...defaultSettings });
    setButtonColors({
      bgColor: defaultBgColor,
      fgColor: defaultFgColor,
    });
    setErrorMessage(""); // Clear any previous error messages
    close();
  };

  return (
    <DialogPopup
      title="SETTLEMENT PORTAL LINK"
      open={open}
      onClose={handleClose}
      PaperProps={{ style: { height: "415px" } }}
    >
      <p className="mb-2">Show the link to the settlement portal as:</p>

      <div style={{ minHeight: "220px" }}>
        <LinkTypeSelector
          selectedValue={settlementPortalSettings.link_type}
          onValueChange={handleLinkTypeChange}
        />

        {settlementPortalSettings.link_type === "alternative text" && (
          <AlternativeTextComponent
            text={settlementPortalSettings.link_text}
            onTextChange={handleTextChange}
            error={errorMessage}
            helperText={errorMessage}
            FormHelperTextProps={{
              className: classes.helperText,
            }}
          />
        )}

        {settlementPortalSettings.link_type === "button" && (
          <ButtonComponent
            text={settlementPortalSettings.button_label}
            onTextChange={handleTextChange}
            bgColor={buttonColors.bgColor}
            fgColor={buttonColors.fgColor}
            onBgColorChange={(color) => handleColorChange("bgColor", color)}
            onFgColorChange={(color) => handleColorChange("fgColor", color)}
            error={errorMessage}
            helperText={errorMessage}
            FormHelperTextProps={{
              className: classes.helperText,
            }}
          />
        )}
      </div>
      {/* 
      <ActionCheckboxes
        autoLogin={settlementPortalSettings.auto_login}
        onAutoLoginChange={(value) =>
          setSettlementPortalSettings((prev) => ({
            ...prev,
            auto_login: value,
          }))
        }
        openPaymentBox={settlementPortalSettings.open_payment_box}
        onOpenPaymentBoxChange={(value) =>
          setSettlementPortalSettings((prev) => ({
            ...prev,
            open_payment_box: value,
          }))
        }
      /> */}

      <div className="action_container">
        <Button className="btn_cancel" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className="btn_confirm"
          style={{ width: "175px" }}
          onClick={handleSubmit}
        >
          {wordClicked ? "Update placeholder" : "Add placeholder"}
        </Button>
      </div>
    </DialogPopup>
  );
}

export default SettlementPortalLinkPopup;
